/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ActivityArea } from './';
import {
    ActivityAreaFromJSON,
    ActivityAreaFromJSONTyped,
    ActivityAreaToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateActivityAreaRequest
 */
export interface UpdateActivityAreaRequest {
    /**
     * 
     * @type {ActivityArea}
     * @memberof UpdateActivityAreaRequest
     */
    activityArea: ActivityArea;
}

/**
 * Check if a given object implements the UpdateActivityAreaRequest interface.
 */
export function instanceOfUpdateActivityAreaRequest(value: object): value is UpdateActivityAreaRequest {
    if (!('activityArea' in value) || value['activityArea'] === undefined) return false;
    return true;
}

export function UpdateActivityAreaRequestFromJSON(json: any): UpdateActivityAreaRequest {
    return UpdateActivityAreaRequestFromJSONTyped(json, false);
}

export function UpdateActivityAreaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateActivityAreaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'activityArea': ActivityAreaFromJSON(json['activityArea']),
    };
}

export function UpdateActivityAreaRequestToJSON(value?: UpdateActivityAreaRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'activityArea': ActivityAreaToJSON(value['activityArea']),
    };
}

